import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudSun01 = function CloudSun01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19.368 12.4048C20.935 11.5606 22 9.9047 22 8c0-2.7614-2.2386-5-5-5s-5 2.2386-5 5m0 0c-2.1377 0-3.9906 1.2196-4.9008 3.001A5 5 0 0 0 7 11c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5h10.5c2.4853 0 4.5-2.0147 4.5-4.5S19.9853 12 17.5 12a5 5 0 0 0-.2057.0046C16.6429 9.6937 14.5192 8 12 8"
    })
  }));
};
export default CloudSun01;